import { useQuery } from "@tanstack/react-query"
import { columns } from "./partial/Columns"
import { DataTable } from "./partial/DataTable"
import api from "@/lib/axios"
import SkeletonTable from "@/components/SkeletonTable"

const getListCapaianPrestasi = async () => {
  const response = await api.get("/master/capaian-prestasi/index", {
    withCredentials: true,
  })
  return response.data?.data
}

export default function MasterCapaianPrestasiPage() {
  const { data, isPending } = useQuery({
    queryKey: ["listCapaianPrestasi"],
    queryFn: getListCapaianPrestasi,
  })

  if (isPending) return <SkeletonTable />

  return (
    <div>
      <DataTable data={data || []} columns={columns} />
    </div>
  )
}
